export const SCROLL_PROCESSING = 'scrollTopProcessing';
export const AXIOS_REQUEST = 'axiosRequests';
export const JS_ERRORS = 'errors';

export interface QaState {
    [AXIOS_REQUEST]: number;
    [SCROLL_PROCESSING]: boolean;
    [JS_ERRORS]: Error[];
}

declare global {
    export interface Window {
        qaState: QaState;
    }
}

export const getInitialState = (): QaState => ({
    [AXIOS_REQUEST]: 0,
    [SCROLL_PROCESSING]: false,
    [JS_ERRORS]: [],
});

let state: QaState | undefined;
const isSsr = typeof window === 'undefined';
if (isSsr) {
    state = undefined;
} else if (window.qaState === undefined) {
    state = getInitialState();
    window.qaState = state;
} else {
    state = window.qaState;
}

export const qaState = state;
